function AboutThisProject({}) {
  return (
    <div id="Information">
      <h3>About this project</h3>
      <p>
        Database of Mechanisms And Reactions of Terpene Synthases (MARTS-DB) is
        a project maintained at the Institute of Organic Chemistry and Biochemistry
        in Prague with the aim of curating the data on all known experimentally characterized terpene synthases, their
        reactions and reaction mechanisms.{" "}
      </p>
      <p>
        This project started as an internal dataset built to train
        machine learning models. The data is now publicly available under the <a href="https://creativecommons.org/licenses/by/4.0/?ref=chooser-v1" target="_blank" rel="license noopener noreferrer" style={{display: "inline-block"}}>CC BY 4.0 <img style={{height:"22px", marginLeft: "3px", verticalAlign: "text-bottom"}} src="https://mirrors.creativecommons.org/presskit/icons/cc.svg?ref=chooser-v1" alt=""/>
          <img style={{height:"22px", marginLeft: "3px", verticalAlign: "text-bottom"}} src="https://mirrors.creativecommons.org/presskit/icons/by.svg?ref=chooser-v1" alt=""/></a> license.
      </p>
    </div>
  );
}

export default AboutThisProject;
